import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { openingCash } from "../../Redux/Action/loginAction";
import { useTranslation } from "react-i18next";
import { cash, opening_cash_icon, OpeningCashDeco } from "../../assets";
import AlphaNumericKeyboardModal from "./AlphaNumericKeyboardModal";
import { detectWebDeviceType } from "../../utils";

const InputField = ({
  label,
  placeholder,
  value,
  type = "text",
  inputMode,
  onChange,
  deviceType,
  setShowKeyboard,
  setKeyboardMode, // ✅ you forgot to access this
}) => {
  const { t } = useTranslation();
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  return (
    <>
      <div className="mt-9 font-medium max-md:max-w-full">{label}</div>
      <div
        style={{ direction: "ltr" }}
        className="flex border-2 border-solid border-gray-300 rounded-xl overflow-hidden justify-center items-start"
      >
        <span className="px-3 py-3 bg-white text-black max-md:pe-3">EGP</span>
        <input
          ref={inputRef}
          type={type}
          inputMode={inputMode}
          readOnly={deviceType === "tablet"} // ✅ disables system keyboard
          placeholder={placeholder}
          value={value}
          onFocus={() => {
            if (deviceType === "tablet") {
              setKeyboardMode?.("numeric"); // ✅ safely call setter
              setShowKeyboard?.(true);
            }
          }}
          onChange={onChange}
          className="p-3 bg-white rounded-xl text-left border-0 border-neutral-400 border-opacity-50 text-black max-md:pr-5 w-full focus:outline-none"
        />
      </div>
    </>
  );
};

const OpeningCash_Modal = ({ onClose }) => {
  const [inputValue, setInputValue] = useState("");
  const userData = useSelector((state) => state?.login?.user?.result);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const deviceType = detectWebDeviceType();
  const [showKeyboard, setShowKeyboard] = useState(false);
  const [keyboardMode, setKeyboardMode] = useState("numeric");

  // console.log("UserData", userData);

  const inputFields = [{ label: "Amount", placeholder: "Enter Amount" }];

  const handleConfirm = async () => {
    try {
      const response = await dispatch(
        openingCash(userData?.session_id, inputValue),
      );
      if (response === true) {
        onClose();
      }
    } catch (error) {
      console.error("Error", error.response.data);
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        handleConfirm();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleConfirm]);

  return (
    <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center z-50 backdrop-blur-md drop-shadow-sm">
      <div className="fixed top-0 left-0 w-full h-full bg-black opacity-50 z-40"></div>
      <section
        className={`flex flex-col justify-center items-center px-12 py-12 text-lg font-semibold leading-6 bg-white rounded-[40px] text-zinc-800 max-md:px-5 z-40 ${
          deviceType === "tablet" ? "fixed left-20" : "relative"
        }`}
        style={{ width: "600px" }}
      >
        <div className="absolute w-full top-0">
          <img src={OpeningCashDeco} alt="ramadanDeco" className="w-full" />
        </div>
        <img src={opening_cash_icon} alt="" className="mb-10" />

        <div className="flex gap-5 text-3xl max-md:flex-wrap max-md:max-w-full">
          <h1 className="flex-auto my-auto">{t("Enter the Opening Cash")}</h1>
        </div>
        <div className="flex justify-center w-[100%] mt-10">
          {inputFields?.map((field, index) => (
            <InputField
              key={index}
              placeholder={t(field.placeholder)}
              value={inputValue}
              type="number"
              inputMode="decimal"
              onChange={(e) => {
                let inputValue = e.target.value;
                inputValue = inputValue.replace(/ز/g, ".");

                if (
                  inputValue?.match(/^\d*\.?\d{0,2}$/) &&
                  inputValue < 10000000
                ) {
                  if (
                    inputValue.length > 1 &&
                    inputValue.replace(".", "") ===
                      "0".repeat(inputValue.replace(".", "").length)
                  ) {
                    return;
                  }
                  setInputValue(inputValue);
                }
              }}
              deviceType={deviceType}
              setShowKeyboard={setShowKeyboard}
              setKeyboardMode={setKeyboardMode}
            />
          ))}
        </div>
        <div className="flex justify-center mt-10 max-md:mt-10">
          <button
            type="submit"
            className="py-3.5 text-xl text-center text-white capitalize whitespace-nowrap bg-[#7EC242] rounded-lg w-[442px] max-md:px-5"
            onClick={handleConfirm}
          >
            {t("Confirm")}
          </button>
        </div>
      </section>
      {deviceType === "tablet" && showKeyboard && (
        <AlphaNumericKeyboardModal
          mode={keyboardMode}
          width="42%"
          maxWidth="42%"
          maxHeight="54%"
          onClose={() => setShowKeyboard(false)}
          onKeyPress={(key) => {
            if (key === "DEL") {
              setInputValue((prev) => prev.slice(0, -1));
            } else if (key === "SPACE") {
              setInputValue((prev) => prev + " ");
            } else {
              const newVal = inputValue + key;
              if (newVal.match(/^\d*\.?\d{0,2}$/) && newVal < 10000000) {
                setInputValue(newVal);
              }
            }
          }}
        />
      )}
    </div>
  );
};

export default OpeningCash_Modal;
